import dayjs from 'dayjs';

export function toArrivalTime(startDate: Date, totalMinutes: number) {
  const startDateJS = dayjs(startDate);
  const endDateJS = startDateJS.add(totalMinutes, 'minute');
  
  const daysDiff = endDateJS.diff(startDateJS, 'day');

  return endDateJS.format('HH:mm') + (daysDiff > 0 ? ` (+${daysDiff}d)` : '');
}